import { render } from "./details.vue?vue&type=template&id=6fe75ed8&ts=true"
import script from "./details.vue?vue&type=script&scoped=true&lang=ts"
export * from "./details.vue?vue&type=script&scoped=true&lang=ts"

import exportComponent from "/usr/src/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__